// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TopUp-waapper .form-item-box[data-v-4bbca90a] {\n  background: rgba(153, 153, 153, 0.075);\n  padding: 40px;\n  color: black;\n}\n.TopUp-waapper .form-item-box .item-title[data-v-4bbca90a] {\n  font-size: 22px;\n  font-weight: 600;\n}\n.TopUp-waapper .form-item-box .item-input-box div[data-v-4bbca90a] {\n  margin-right: 40px;\n}\n.TopUp-waapper .option-btn[data-v-4bbca90a] {\n  font-size: 13px;\n  color: #0c7efe;\n  display: inline-block;\n  margin-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
